import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import MainPage from "@/pages/MainPage";
import FeaturedPage from "@/pages/FeaturedPage";
import MostRecentPage from "@/pages/MostRecentPage";
import LatestPostsPage from "@/pages/LatestPostsPage";
import PostDetailPage from "@/pages/PostDetailPage";
import AdminPage from "@/pages/AdminPage";
import SubmitPressReleasePage from "@/pages/SubmitPressReleasePage";
import BillingPage from "@/pages/BillingPage";
import FaqsPage from "@/pages/FaqsPage";
import AboutPage from "@/pages/AboutPage";
import MissionPage from "@/pages/MissionPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CategoriesPage from "@/pages/CategoriesPage";
import EventsPage from "@/pages/EventsPage";
import SubscribePage from "@/pages/SubscribePage";
import ContactPage from "@/pages/ContactPage";
import SearchResultsPage from "@/pages/SearchResultsPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<MainPage />} />
                        <Route path="/featured" element={<FeaturedPage />} />
                        <Route path="/recent" element={<MostRecentPage />} />
                        <Route path="/latest" element={<LatestPostsPage />} />
                        <Route path="/post/:slug" element={<PostDetailPage />} />

                        <Route path="/submit-press-release" element={<SubmitPressReleasePage />} />
                        <Route path="/submit-press-release/billing" element={<BillingPage />} />
                        <Route path="/submit-press-release/faqs" element={<FaqsPage />} />

                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/about/mission" element={<MissionPage />} />
                        <Route path="/about/privacy" element={<PrivacyPage />} />
                        <Route path="/about/terms" element={<TermsPage />} />

                        <Route path="/categories" element={<CategoriesPage />} />
                        <Route path="/events" element={<EventsPage />} />
                        <Route path="/subscribe" element={<SubscribePage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/search" element={<SearchResultsPage />} />
                    </Route>
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
